// ISO Alpha-2 and Alpha-3 country codes

const countriesCodes = {
	'Antigua y Barbuda': ['AG', 'ATG'],
	Argentina: ['AR', 'ARG'],
	Bahamas: ['BS', 'BHS'],
	Barbados: ['BB', 'BRB'],
	Belice: ['BZ', 'BLZ'],
	Bolivia: ['BO', 'BOL'],
	Brasil: ['BR', 'BRA'],
	Canadá: ['CA', 'CAN'],
	Chile: ['CL', 'RCH'],
	China: ['CN', 'CHN'],
	Colombia: ['CO', 'COL'],
	'Corea del Sur': ['KR', 'KOR'],
	'Costa Rica': ['CR', 'CRI'],
	Cuba: ['CU', 'CUB'],
	Dominica: ['DM', 'DMA'],
	Ecuador: ['EC', 'ECU'],
	'El Salvador': ['SV', 'SLV'],
	'Estados Unidos de América': ['US', 'USA'],
	Granada: ['GD', 'GRD'],
	Guatemala: ['GT', 'GTM'],
	Guyana: ['GY', 'GUY'],
	Haiti: ['HT', 'HTI'],
	Honduras: ['HN', 'HND'],
	Islandia: ['IS', 'ISL'],
	Israel: ['IL', 'ISR'],
	Jamaica: ['JM', 'JAM'],
	Liechtenstein: ['LI', 'LIE'],
	Montserrat: ['MS', 'MSR'],
	México: ['MX', 'MEX'],
	Noruega: ['NO', 'NOR'],
	Panamá: ['PA', 'PAN'],
	Paraguay: ['PY', 'PRY'],
	Perú: ['PE', 'PER'],
	'San Cristobal y Nieves': ['KN', 'KNA'],
	'San vicente y las Granadinas': ['VC', 'VCT'],
	'Santa Lucía': ['LC', 'LCA'],
	Suiza: ['CH', 'CHE'],
	Surinam: ['SR', 'SUR'],
	'Trinidad y Tobago': ['TT', 'TTO'],
	'Unión Europea': [
		['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'],
		['AUT', 'BEL', 'BGR', 'HRV', 'CYP', 'CZE', 'DNK', 'EST', 'FIN', 'FRA', 'DEU', 'GRC', 'HUN', 'IRL', 'ITA', 'LVA', 'LTC', 'LUX', 'MLT', 'NLD', 'POL', 'PRT', 'ROU', 'SVK', 'SVN', 'ESP', 'SWE'],
	],
	Uruguay: ['UY', 'URY'],
};

export default countriesCodes;
